"use strict";
exports.__esModule = true;
var DEFAULT_ASSIGN_MSG = "Changed through Assign Categories.";
var TreeParserForCategory = /** @class */ (function () {
    function TreeParserForCategory(treeData, categoryContents, saveCategoryNodesList, tagsPropagateUp) {
        if (tagsPropagateUp === void 0) { tagsPropagateUp = true; }
        var _this = this;
        this.firstColTemplate =
            '<div class="ui-grid-cell-contents nodename" ng-class="row.entity.indentClass">' +
                '<span ng-class="{platformNode: row.entity.isPlatform}" ' +
                'ng-cell-text>{{COL_FIELD}}</span>' +
                // '<button ng-click="grid.appScope.debugFunc(row, col)">debug</button>' +
                '</div>';
        this.colCellTemplate =
            '<div class="checkboxOuter">' +
                // Radio button is not working properly if name/ng-checked set together.
                '<input ng-disabled="row.entity.readOnly" class="tagCheckBox" ' +
                'ng-class="{radioLike:!grid.appScope.currentIsMult}" type="radio" style="width: auto" ' +
                // 'name="{{row.entity.id}}" ' +
                'ng-if="!grid.appScope.currentIsMult && (row.entity.leaf || (grid.appScope.applyToPlatform && row.entity.isPlatform))" ' +
                'ng-checked="COL_FIELD" ' +
                'ng-click="grid.appScope.toggleLeafCat(col.field, row, COL_FIELD)" />' +
                '<input ng-disabled="row.entity.readOnly" type="checkbox" class="tagCheckBox" style="width: auto" ' +
                'name="{{row.entity.id}}" ' +
                'ng-if="grid.appScope.currentIsMult && (row.entity.leaf || (grid.appScope.applyToPlatform && row.entity.isPlatform))" ' +
                'ng-checked="COL_FIELD" ' +
                'ng-click="grid.appScope.toggleLeafCat(col.field, row, COL_FIELD)" />' +
                '<input ng-disabled="grid.appScope.AutoPropagateUp || row.entity.readOnly" type="checkbox" ' +
                'name="{{row.entity.id}}" ' +
                'ng-if="!row.entity.leaf && !(grid.appScope.applyToPlatform && row.entity.isPlatform)" ' +
                'class="tagCheckBox" ' +
                'ng-checked="COL_FIELD" ' +
                'ng-click="grid.appScope.toggleParentTag(col.field, row, COL_FIELD)" />' +
                '</div>';
        this.headerCellTemplate =
            '<div>' +
                '<div class="ui-grid-cell-contents" col-index="renderIndex" title="TOOLTIP">' +
                '<span>{{ col.field CUSTOM_FILTERS }}</span>' +
                '</div>' +
                '<div ui-grid-filter class="ascate-grid-filter" style="font-weight: normal;"></div></div>';
        var headerCellTemplateCenter = '<div>' +
            '<div class="ui-grid-cell-contents" col-index="renderIndex" title="TOOLTIP" style="text-align: center;">' +
            '<span>{{ col.field CUSTOM_FILTERS }}</span>' +
            '</div>' +
            '</div>';
        this.nodes = new Array();
        this.saveCategoryNodesList = saveCategoryNodesList;
        this.process(treeData, "", 1);
        this.rootNode = this.nodes[0];
        this.createIDHash();
        this.categoryContents = categoryContents;
        this.colConfigList = [];
        this.tagsPropagateUp = tagsPropagateUp;
        this.categoryContents.forEach(function (category) {
            var colConfig = [{
                    field: "name",
                    displayName: "Node",
                    cellTemplate: _this.firstColTemplate,
                    width: '300',
                    headerCellTemplate: _this.headerCellTemplate,
                    pinned: true,
                    enableFiltering: true,
                    filter: {
                        placeholder: "Search Node ..."
                    }
                }];
            for (var i = 0; i < category.CategoryEntries.length; i++) {
                if (category.CategoryEntries[i] !== 'all') {
                    colConfig.push({
                        field: category.CategoryEntries[i],
                        cellTemplate: _this.colCellTemplate,
                        headerCellTemplate: headerCellTemplateCenter,
                        width: '80',
                        enableFiltering: false
                    });
                }
            }
            _this.colConfigList.push(colConfig);
        });
        this.currentCate = this.categoryContents[0];
        this.currentIsMult = this.categoryContents[0]['IsMultiSelect'] === 'true';
        this.AutoPropagateUp = this.categoryContents[0]['AutoPropagateUp'] === 'true';
        this.generateIndentClass();
        this.nodes.forEach(function (ele, index) {
            ele['index'] = index;
        });
        this.platformNodesList = [];
        this.generatePlatformNodesList();
        if (this.categoryContents[0]['AppliesTo'] === 'Platform') {
            this.currentNodes = this.platformNodesList;
        }
        else {
            this.currentNodes = this.nodes;
        }
    }
    TreeParserForCategory.prototype.createIDHash = function () {
        var _this = this;
        this.idHash = {};
        this.nodes.forEach(function (ele, index) {
            _this.idHash[ele.id] = index;
        });
    };
    TreeParserForCategory.prototype.getCurrentNodes = function () {
        return this.currentNodes;
    };
    TreeParserForCategory.prototype.generatePlatformNodesList = function () {
        var index = 0;
        while (index < this.nodes.length) {
            this.platformNodesList.push(this.nodes[index]);
            if (this.nodes[index].isPlatform) {
                var platformLevel = this.nodes[index].indent;
                while (index + 1 < this.nodes.length && this.nodes[index + 1].indent > platformLevel) {
                    index++;
                }
            }
            index++;
        }
    };
    TreeParserForCategory.prototype.process = function (subtree, path, indent) {
        if (subtree.Tags.slice(-1) === ' ') {
            var tags = subtree.Tags.slice(0, -1);
        }
        else {
            var tags = subtree.Tags;
        }
        var readOnly = subtree.readOnly || false;
        var isisPlatform = subtree.isPlatform == 'True';
        if (subtree.Children !== undefined && subtree.Children.length > 0) {
            var node = {
                id: subtree._id,
                parentID: subtree.parentID,
                isPlatform: isisPlatform,
                name: subtree.Name,
                path: path,
                tags: tags,
                indent: indent,
                leaf: false,
                readOnly: readOnly
            };
            this.nodes.push(node);
            for (var i = 0; i < subtree.Children.length; i++) {
                this.process(subtree.Children[i], path + subtree.Name + ">", indent + 1);
            }
        }
        else {
            var node = {
                id: subtree._id,
                parentID: subtree.parentID,
                isPlatform: isisPlatform,
                name: subtree.Name,
                path: path,
                tags: tags,
                indent: indent,
                leaf: true,
                readOnly: readOnly
            };
            this.nodes.push(node);
        }
    };
    TreeParserForCategory.prototype.getAllCateEntries = function () {
        return this.categoryContents.reduce(function (meno, cate) {
            return meno.concat(cate.CategoryEntries);
        }, []);
    };
    TreeParserForCategory.prototype.collectChildrenCat = function (nodeIndex) {
        var _this = this;
        if (this.nodes[nodeIndex].leaf) {
            return;
        }
        var parentIndent = this.nodes[nodeIndex].indent;
        var catCollector = ['all'];
        for (var i = nodeIndex + 1; i < this.nodes.length; i++) {
            if (this.nodes[i].indent <= parentIndent) {
                break;
            }
            var newTags = this.nodes[i].tags.split(',').filter(function (ele) {
                return ele.indexOf(_this.currentCate['CategoryName']) === 0;
            });
            catCollector = catCollector.concat(newTags);
        }
        var newCatList = catCollector.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });
        var oldTgas = this.nodes[nodeIndex].tags.split(',').filter(function (ele) {
            return ele.indexOf(_this.currentCate['CategoryName']) === -1;
        });
        this.nodes[nodeIndex].tags = oldTgas.concat(newCatList).join(',');
        return [this.nodes[nodeIndex].id, this.nodes[nodeIndex].tags];
    };
    TreeParserForCategory.prototype.collectChildrenCatForParent = function (nodeIndex) {
        if (this.nodes[nodeIndex].leaf) {
            return;
        }
        var parentIndent = this.nodes[nodeIndex].indent;
        var childrenIds = [];
        for (var i = nodeIndex + 1; i < this.nodes.length; i++) {
            if (this.nodes[i].indent <= parentIndent) {
                break;
            }
            childrenIds.push(this.nodes[i]['id']);
        }
        return childrenIds;
    };
    TreeParserForCategory.prototype.toggleNoneLeafCat = function (nodeIndex, category, categoryEntree) {
        if (this.nodes[nodeIndex].leaf) {
            return;
        }
        var catList = this.nodes[nodeIndex].tags.split(',');
        var cateString = category + ':' + categoryEntree;
        if (catList.indexOf(cateString) === -1) {
            catList.push(cateString);
            this.nodes[nodeIndex].tags = catList.join(',');
        }
    };
    TreeParserForCategory.prototype.downwardFromPlatform = function (nodeIndex, category, categoryEntree) {
        var scanIndex = nodeIndex + 1;
        var platformDepth = this.nodes[nodeIndex].indent;
        var saveList = [];
        while (scanIndex < this.nodes.length) {
            if (this.nodes[scanIndex].indent <= platformDepth) {
                break;
            }
            if (this.currentIsMult) {
                saveList.push(this.toggleCheckNode(scanIndex, category, categoryEntree));
            }
            else {
                saveList.push(this.toggleRadioNode(scanIndex, category, categoryEntree));
            }
            scanIndex++;
        }
        return saveList;
    };
    TreeParserForCategory.prototype.getPrevEntry = function (nodeIndex, category) {
        var res = [];
        this.nodes[nodeIndex].tags.split(',').forEach(function (tag) {
            if (tag === 'all')
                return;
            var _a = tag.split(':'), cate = _a[0], entry = _a[1];
            if (cate === category) {
                res.push(entry);
            }
        });
        return res.length ? res.join(', ') : '';
    };
    TreeParserForCategory.prototype.toggleRadioNode = function (nodeIndex, category, categoryEntree) {
        var catList = this.nodes[nodeIndex].tags.split(',');
        if (this.findCategory(nodeIndex, category, categoryEntree)) {
            var index = catList.indexOf(category + ':' + categoryEntree);
            catList.splice(index, 1);
        }
        else {
            var catIndex = catList.indexOf(catList.find(function (ele) {
                return ele.indexOf(category) !== -1;
            }));
            if (catIndex !== -1) {
                catList.splice(catIndex, 1);
                catList.push(category + ':' + categoryEntree);
            }
            else {
                catList.push(category + ':' + categoryEntree);
            }
        }
        this.nodes[nodeIndex].tags = catList.join(',');
        return [this.nodes[nodeIndex].id, this.nodes[nodeIndex].tags];
    };
    TreeParserForCategory.prototype.toggleCheckNode = function (nodeIndex, category, categoryEntree) {
        var catList = this.nodes[nodeIndex].tags.split(',');
        if (this.findCategory(nodeIndex, category, categoryEntree)) {
            var index = catList.indexOf(category + ':' + categoryEntree);
            catList.splice(index, 1);
        }
        else {
            catList.push(category + ':' + categoryEntree);
        }
        this.nodes[nodeIndex].tags = catList.join(',');
        if (!this.AutoPropagateUp) {
            this.saveCategoryNodesList([[this.nodes[nodeIndex].id, this.nodes[nodeIndex].tags]]);
        }
        return [this.nodes[nodeIndex].id, this.nodes[nodeIndex].tags];
    };
    TreeParserForCategory.prototype.toggleLeafCat = function (nodeIndex, category, categoryEntree) {
        var SaveList = [];
        var childrenIds = [];
        var CategoryLog = {};
        var lastVal = this.getPrevEntry(nodeIndex, category);
        if (this.currentIsMult) {
            SaveList.push(this.toggleCheckNode(nodeIndex, category, categoryEntree));
        }
        else {
            SaveList.push(this.toggleRadioNode(nodeIndex, category, categoryEntree));
        }
        if (this.currentCate['AppliesTo'] === 'Platform' && this.nodes[nodeIndex].isPlatform) {
            SaveList = SaveList.concat(this.downwardFromPlatform(nodeIndex, category, categoryEntree));
        }
        if (this.AutoPropagateUp && this.tagsPropagateUp) {
            var parentID = this.nodes[nodeIndex].parentID;
            while (parentID !== '' && parentID in this.idHash) {
                var parentIndex = this.idHash[parentID];
                SaveList.push(this.collectChildrenCat(parentIndex));
                parentID = this.nodes[parentIndex].parentID;
            }
        }
        else if (!this.tagsPropagateUp) {
            var parentID = this.nodes[nodeIndex].parentID;
            if (parentID && parentID in this.idHash) {
                var parentIndex = this.idHash[parentID];
                childrenIds = this.collectChildrenCatForParent(parentIndex);
            }
        }
        CategoryLog[category] = { 'lastVal': lastVal, 'msg': '', 'universalTableComment': DEFAULT_ASSIGN_MSG };
        this.saveCategoryNodesList(SaveList, CategoryLog);
        return childrenIds;
    };
    TreeParserForCategory.prototype.generateIndentClass = function () {
        for (var i = 0; i < this.nodes.length; i++) {
            var indentClass = 'level' + this.nodes[i].indent;
            this.nodes[i].indentClass = indentClass;
        }
    };
    TreeParserForCategory.prototype.findCategory = function (nodeIndex, category, categoryEntree) {
        return this.nodes[nodeIndex].tags.split(',').indexOf(category + ':' + categoryEntree) !== -1;
    };
    TreeParserForCategory.prototype.changeCategory = function (cateIndex) {
        if (this.categoryContents[cateIndex]['AppliesTo'] === 'Platform') {
            this.currentNodes = this.platformNodesList;
        }
        else {
            this.currentNodes = this.nodes;
        }
        this.currentCate = this.categoryContents[cateIndex];
        this.currentIsMult = this.categoryContents[cateIndex]['IsMultiSelect'] === 'true';
        this.AutoPropagateUp = this.categoryContents[cateIndex]['AutoPropagateUp'] === 'true';
    };
    TreeParserForCategory.prototype.getColConfig = function (index) {
        return this.colConfigList[index];
    };
    TreeParserForCategory.prototype.splitTags = function (stringToSplit, charToSplitOn) {
        if (stringToSplit.slice(-1) === ' ') {
            stringToSplit = stringToSplit.slice(0, -1);
        }
        var splitArray = stringToSplit.split(charToSplitOn);
        for (var i = 0; i < splitArray.length; i++) {
            splitArray[i] = this.trim(splitArray[i]);
        }
        return splitArray;
    };
    TreeParserForCategory.prototype.trim = function (str) {
        str = str.replace(/^\s+/, '');
        for (var i = str.length - 1; i >= 0; i--) {
            if (/\S/.test(str.charAt(i))) {
                str = str.substring(0, i + 1);
                break;
            }
        }
        return str;
    };
    TreeParserForCategory.prototype.tagsToString = function (tags) {
        var s = "";
        var tagdict = {};
        for (var i = 0; i < tags.length; i++) {
            if (tagdict[tags[i]] === undefined) {
                s += tags[i];
                tagdict[tags[i]] = true;
                if (i < tags.length - 1) {
                    s += ",";
                }
            }
        }
        return s;
    };
    TreeParserForCategory.prototype.toggleTag = function (node, tag) {
        var tags = this.splitTags(node.tags, ",");
        var locOfTag = tags.indexOf(tag);
        if (locOfTag === -1) {
            node.tags = node.tags + "," + tag;
        }
        else {
            tags.splice(locOfTag, 1);
            node.tags = this.tagsToString(tags);
        }
    };
    TreeParserForCategory.prototype.doesTagExistOnRootNode = function (tag) {
        return this.doesTagExistOnNode(tag, this.rootNode);
    };
    TreeParserForCategory.prototype.doesTagExistOnNode = function (tag, node) {
        var match = false;
        tag = tag.toUpperCase();
        var tags = this.splitTags(node.tags, ",");
        for (var i = 0; i < tags.length; i++) {
            if (tag === tags[i].toUpperCase()) {
                match = true;
            }
        }
        return match;
    };
    return TreeParserForCategory;
}());
exports["default"] = TreeParserForCategory;
//# sourceMappingURL=category-tree-parser.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/assign-category/app/js/logic/category-tree-parser.js